import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import React, {useEffect, useState} from "react";
import Form from "../../components/common/form/Form";
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {fromCamelCaseToTitle} from "../../components/Utility";
import {assignEmployee} from "../../store/employee-slice";
import {assignEmployeeSchema} from "../../schema/employeeSchema";
import {getEmployeeAssignFormData} from "../../models/employeeModel";
import {fetchInternalBranchList} from "../../store/list-slice";
import AlertMessage from "../../components/ui/AlertMessage";

const EmployeeAssign = () => {
    const params = useParams();
    const navigator = useNavigate();
    const dispatch = useDispatch();
    const userRole = useSelector((state) => state.auth.selectedRole);
    const [alertInfo, setAlertInfo] = useState(null);

    const list = useSelector(state => state.list);
    const {
        assignEmployeeStatus,
        error
    } = useSelector(state => state.employee);

    const employeeName = fromCamelCaseToTitle(params.employeeName);

    const showAlert = (message, variant = 'info') => {
        setAlertInfo({message, variant});
    };

    useEffect(() => {
        if (assignEmployeeStatus === "success") {
            showAlert("Employee assigned to branch successfully", 'success');
            setTimeout(() => {
                navigator("../../");
            }, 1000); // 1 second
        }
    }, [assignEmployeeStatus, navigator]);

    useEffect(() => {
        dispatch(fetchInternalBranchList(userRole));
    }, [dispatch, userRole])

    const formSubmitHandler = (data) => {
        const updatedData = {
            ...data,
            user: params.employeeId
        }

        dispatch(assignEmployee({
            ...userRole,
            data: updatedData
        }));
    };

    const formCancelHandler = () => {
        navigator("../../"); // Adjust the navigation path as needed
    };

    const schema = assignEmployeeSchema({list});
    const initialData = getEmployeeAssignFormData();
    return (
        <>
            <SubHeader title={`Assign Employee - ${employeeName}`}>
                <Button to="../../" className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                <div className="row">
                    <div className="col-xl-8">
                        <Form
                            onFormSubmit={formSubmitHandler}
                            onFormCancel={formCancelHandler}
                            schema={schema}
                            inline={false}
                            initialData={initialData}
                            status={assignEmployeeStatus}
                            error={error}
                        />
                    </div>
                </div>
            </div>
            {/*Alert*/}
            {alertInfo && (
                <AlertMessage
                    message={alertInfo.message}
                    variant={alertInfo.variant}
                    duration={2000}
                    onClose={() => setAlertInfo(null)}
                />
            )}
        </>
    )
}

export default EmployeeAssign;